export const showSnackbar = (content) => {
   return (dispatch) => {
      dispatch({
         type: 'SHOW_SNACKBAR_REQUEST',
         data: content
      })
   }
}

export const closeSnackbar = (content) => {
   return (dispatch) => {
      dispatch({
         type: 'HIDE_SNACKBAR_REQUEST'
      })
   }
}


// WEBPACK FOOTER //
// ./src/actions/snackbarActions.js